import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/app';
import { Provider } from 'react-redux';
import { store } from './app/redux/store';
import { MediaPreviewProvider } from './app/components/PreviewAvatarMedia/MediaPreviewProvider';
import YandexMetrika from './app/components/YandexMetrika/YandexMetrika';
import { TabsProvider } from './app/components/Tabs/TabsProvider';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <MediaPreviewProvider>
          <TabsProvider>
            <YandexMetrika />
            <App />
          </TabsProvider>
        </MediaPreviewProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
